/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{nativeArrayMaxSize as r,isArray as n}from"../../core/typedArrayUtil.js";function t(n,t=!1){return n<=r?t?new Array(n).fill(0):new Array(n):new Uint32Array(n)}function e(t){return(n(t)?t.length:t.byteLength/8)<=r?Array.from(t):new Uint32Array(t)}function y(r,n,t){return Array.isArray(r)?r.slice(n,n+t):r.subarray(n,n+t)}export{t as newUintArray,e as uintArrayFrom,y as uintSubArray};
